import {
    REQUEST_ORDER_DETAILS,
    REQUEST_ORDER_DETAILS_FAILURE,
    REQUEST_ORDER_DETAILS_SUCCESS
} from "../../../constant/transaction/OrderDetailContant";


const initialState = {
    orderDetails: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const orderDetailsReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_ORDER_DETAILS:
            return {
                ...state,
                orderDetails: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                orderDetails: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_ORDER_DETAILS_FAILURE:
            return {
                ...state,
                orderDetails: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
